import { Action } from '@ngrx/store';
import { SearchResultModel } from './search-result.model';

export const ADD_CUSTOM_VALUE = '[SearchAsYouType] Add Custom Value';
export const ADD_VALUE = '[SearchAsYouType] Add Value';
export const DESTROY = '[SearchAsYouType] Destroy';
export const HIGHLIGHT_FIRST_RESULT = '[SearchAsYouType] Select First Result';
export const HIGHLIGHT_LAST_RESULT = '[SearchAsYouType] Select Last Result';
export const HIGHLIGHT_NEXT_RESULT = '[SearchAsYouType] Highlight Next Result';
export const HIGHLIGHT_PREV_RESULT = '[SearchAsYouType] Highlight Prev Result';
export const REMOVE_VALUE = '[SearchAsYouType] Remove Value';
export const RESET_SEARCH_VALUE = '[SearchAsYouType] Reset Search Value';
export const SELECT_HIGHLIGHTED_RESULT = '[SearchAsYouType] Select Highlighted Result';
export const SELECT_RESULT = '[SearchAsYouType] Select Result';
export const SET_ALLOW_CUSTOM_VALUES = '[SearchAsYouType] Set Allow Custom Values';
export const SET_DATA_PROVIDER_SERVICE_ID = '[SearchAsYouType] Set Data Provider Service Id';
export const SET_MULTIPLE = '[SearchAsYouType] Set Multiple';
export const SET_RESULTS = '[SearchAsYouType] Set Results';
export const SET_SEARCH_VALUE = '[SearchAsYouType] Set Search Value';
export const SET_SHOW_ALL_RESULTS = '[SearchAsYouType] Set Show All Results';
export const SET_SHOW_RESULTS = '[SearchAsYouType] Set Show Results';
export const SET_VALUE = '[SearchAsYouType] Set Value';

export class ActionAddCustomValue implements Action {
    readonly type = ADD_CUSTOM_VALUE;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionAddValue implements Action {
    readonly type = ADD_VALUE;

    constructor(public payload: {instanceId: string, value: SearchResultModel}) {
    }
}

export class ActionDestroy implements Action {
    readonly type = DESTROY;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionHighlightFirstResult implements Action {
    readonly type = HIGHLIGHT_FIRST_RESULT;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionHighlightLastResult implements Action {
    readonly type = HIGHLIGHT_LAST_RESULT;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionHighlightNextResult implements Action {
    readonly type = HIGHLIGHT_NEXT_RESULT;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionHighlightPrevResult implements Action {
    readonly type = HIGHLIGHT_PREV_RESULT;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionSelectHighlightedResult implements Action {
    readonly type = SELECT_HIGHLIGHTED_RESULT;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionRemoveValue implements Action {
    readonly type = REMOVE_VALUE;

    constructor(public payload: {instanceId: string, id: string}) {
    }
}

export class ActionResetSearchValue implements Action {
    readonly type = RESET_SEARCH_VALUE;

    constructor(public payload: {instanceId: string}) {
    }
}

export class ActionSelectResult implements Action {
    readonly type = SELECT_RESULT;

    constructor(public payload: {instanceId: string, resultId: string}) {
    }
}

export class ActionSetAllowCustomValues implements Action {
    readonly type = SET_ALLOW_CUSTOM_VALUES;

    constructor(public payload: {instanceId: string, allowCustomValues: boolean}) {
    }
}

export class ActionSetDataProviderServiceId implements Action {
    readonly type = SET_DATA_PROVIDER_SERVICE_ID;

    constructor(public payload: {instanceId: string, dataProviderServiceId: string}) {
    }
}

export class ActionSetMultiple implements Action {
    readonly type = SET_MULTIPLE;

    constructor(public payload: {instanceId: string, multiple: boolean}) {
    }
}

export class ActionSetResults implements Action {
    readonly type = SET_RESULTS;

    constructor(public payload: {instanceId: string, results: Array<SearchResultModel>}) {
    }
}

export class ActionSetSearchValue implements Action {
    readonly type = SET_SEARCH_VALUE;

    constructor(public payload: {instanceId: string, searchValue: string}) {
    }
}

export class ActionSetShowAllResults implements Action {
    readonly type = SET_SHOW_ALL_RESULTS;

    constructor(public payload: {instanceId: string, showAllResults: boolean}) {
    }
}

export class ActionSetShowResults implements Action {
    readonly type = SET_SHOW_RESULTS;

    constructor(public payload: {instanceId: string, showResults: boolean}) {
    }
}

export class ActionSetValue implements Action {
    readonly type = SET_VALUE;

    constructor(public payload: {instanceId: string, value: Array<SearchResultModel>}) {
    }
}

export declare type Actions
    = ActionAddCustomValue
    | ActionAddValue
    | ActionHighlightFirstResult
    | ActionHighlightLastResult
    | ActionHighlightNextResult
    | ActionHighlightPrevResult
    | ActionSelectHighlightedResult
    | ActionRemoveValue
    | ActionResetSearchValue
    | ActionSelectResult
    | ActionSetAllowCustomValues
    | ActionSetMultiple
    | ActionSetResults
    | ActionSetSearchValue
    | ActionSetShowAllResults
    | ActionSetShowResults
    | ActionSetValue
    ;



// WEBPACK FOOTER //
// ./src/app/atoms/search-as-you-type/search-as-you-type.actions.ts